// extracted by mini-css-extract-plugin
export default {"container":"PartnerLogo_container__NcIOj"};